import {
  ScmIntegrationsApi,
  scmIntegrationsApiRef,
  ScmAuth,
} from '@backstage/integration-react';
import {
  AnyApiFactory,
  configApiRef,
  createApiFactory,
  discoveryApiRef,
  identityApiRef,
} from '@backstage/core-plugin-api';
import { techRadarApiRef } from '@backstage/plugin-tech-radar';
import { CustomArgoCDApiClient, customArgoCDApiRef } from './apis/ArgoCDApi';
import { CustomTechRadarApi } from './apis/TechRadarApi';

export const apis: AnyApiFactory[] = [
  createApiFactory({
    api: scmIntegrationsApiRef,
    deps: { configApi: configApiRef },
    factory: ({ configApi }) => ScmIntegrationsApi.fromConfig(configApi),
  }),
  ScmAuth.createDefaultApiFactory(),

  createApiFactory({
    api: customArgoCDApiRef,
    deps: {
      discoveryApi: discoveryApiRef,
      identityApi: identityApiRef,
      configApi: configApiRef,
    },
    factory: ({ discoveryApi, identityApi, configApi }) =>
      new CustomArgoCDApiClient({
        discoveryApi,
        identityApi,
        backendBaseUrl: configApi.getString('backend.baseUrl'),
        searchInstances: Boolean(
          configApi.getOptionalConfigArray('argocd.appLocatorMethods')?.length,
        ),
      }),
  }),

  createApiFactory({
    api: techRadarApiRef,
    deps: {
      identityApi: identityApiRef,
      configApi: configApiRef,
    },
    factory: ({ identityApi, configApi }) => {
      return new CustomTechRadarApi(
        identityApi,
        configApi.getString('backend.baseUrl'),
      );
    },
  }),
];
